module.exports = __webpack_public_path__ + "static/media/shirt-cooperate-2.c4a0c6ed.jpg";